<template>
  <div>
    <div class="service-nav">
      <div class="title">
        <div>說明與服務</div>
      </div>
      <div class="link">
        <router-link to="/gold/service_mobile/service_shop"
          >台南營業處</router-link
        >
        <router-link to="/gold/service_mobile/service_factory"
          >工廠</router-link
        >
        <router-link
          @click.native="closeChildNav"
          to="/gold/service_mobile/service_quoted_price"
          >即時報價系統</router-link
        >
        <div>
          <router-link to="/gold/service_mobile/service_payment">
            <div
              v-on:click="showPaymentNav"
              v-bind:class="{ active: isActive }"
            >
              購買與付款
            </div>
          </router-link>
          <ul v-show="isShowPaymentNav">
            <li><a href="#anchor_process">購買流程</a></li>
            <li><a href="#anchor_howBuy">如何購買？</a></li>
            <li><a href="#anchor_order">確認訂單</a></li>
            <li><a href="#anchor_pay">付款</a></li>
            <li><a href="#anchor_payment">營業稅</a></li>
            <li><a href="#anchor_period">訂單有效期限</a></li>
            <li><a href="#anchor_cancel">取消訂單</a></li>
            <li><a href="#anchor_return">退貨</a></li>
            >
            <li><a href="#anchor_noArticle">缺貨</a></li>
            <li><a href="#anchor_adjustment">價格調整政策</a></li>
          </ul>
        </div>
        <div>
          <router-link to="/gold/service_mobile/service_shipping">
            <div v-on:click="showShippingNav">出貨與物流處理費</div>
          </router-link>
          <ul v-show="isShowShippingNav">
            <li><a>商品寄送</a></li>
            <li><a>自行取貨</a></li>
          </ul>
        </div>
        <router-link to="/gold/service_mobile/service_goldprice"
          >標準貴金屬重量計算方式</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "serviceNav",
  data() {
    return {
      isShowPaymentNav: false,
      isShowShippingNav: false,
      isActive: false,
    };
  },
  methods: {
    showPaymentNav() {
      this.isShowPaymentNav = !this.isShowPaymentNav;
    },
    showShippingNav() {
      this.isShowShippingNav = !this.isShowShippingNav;
    },
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.service-nav > * {
  font-weight: 600;
  line-height: 40px;
}
.service-nav {
  height: 100%;
  padding: 24.5px 10.2%;
  color: $primaryDeepColor;
  background-color: rgba($primaryLightColor, 0.25);
}
.title {
  font-size: 24px;
  padding: 4px 0;
  border-top: 3px solid $primaryDeepColor;
  border-bottom: 3px solid $primaryDeepColor;
}
.title::before,
.title::after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background-color: $primaryDeepColor;
}
.link {
  padding-top: 18.5px;
  padding-bottom: 30px;
}
.link > * {
  border-bottom: 1px solid $primaryDeepColor;
}
.link > *:nth-child(1) {
  border-top: 1px solid $primaryDeepColor;
}
a {
  display: block;
  font-size: 17px;
  color: $primaryDeepColor;
}
a:focus {
  background-color: $primaryDeepColor;
  color: $secondaryColor3;
}
a:hover {
  color: $secondaryColor3;
  background-color: $primaryDeepColor;
}
ul {
  display: block;
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: left;
  font-size: 17px;
  font-weight: normal;
}
</style>
